module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('body', {
    staticClass: "hold-transition login-page "
  }, [_c('div', {
    staticClass: "login-box m-box",
    staticStyle: {
      "width": "400px !important"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box login-bbox"
  }, [_c('div', {
    staticClass: "box-body login-card-body pd-20"
  }, [_c('p', {
    staticClass: "login-box-msg login-txt"
  }, [_vm._v("Sign In")]), _vm._v(" "), _c('md-field', {
    class: _vm.getValidationClass('email')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Email address")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "autocomplete": "email"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  }), _vm._v(" "), (!_vm.$v.form.email.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The email is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.form.email.required && this.formBackendValidation.email.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.formBackendValidation.email.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('md-field', {
    class: _vm.getValidationClass('password')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  }), _vm._v(" "), (!_vm.$v.form.password.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The password is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.form.password.required && this.formBackendValidation.password.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.formBackendValidation.password.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
    staticClass: "btn-signup pull-right",
    attrs: {
      "to": "/user/forgot-password"
    }
  }, [_vm._v("Forgot Password?")]), _vm._v(" "), _c('md-checkbox', {
    staticClass: "md-primary",
    staticStyle: {
      "margin": "0"
    },
    model: {
      value: (_vm.rememberMe),
      callback: function($$v) {
        _vm.rememberMe = $$v
      },
      expression: "rememberMe"
    }
  }, [_vm._v("Remember Me")]), _vm._v(" "), _c('md-card-actions', {
    staticClass: "lg-sp"
  }, [_c('md-button', {
    staticClass: "rgbtnn md-raised md-accent login-btn btn-block",
    on: {
      "click": _vm.validateSubmission
    }
  }, [_vm._v("Login")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-mb-6",
    staticStyle: {
      "text-align": "center",
      "font-size": "13px"
    }
  }, [_vm._v("\n          New to Rubbermaid Commercial Products Smart App?"), _c('br'), _vm._v(" Sign Up For Your\n           "), _c('spam', [_c('router-link', {
    staticClass: "btn-signup",
    staticStyle: {
      "color": "red !important"
    },
    attrs: {
      "to": "/user/register"
    }
  }, [_vm._v("Account Here")])], 1)], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo"
  }, [_c('img', {
    staticClass: "logo-login-signup",
    attrs: {
      "src": "/static/img/crp-images/Logo_RCP_Smart_App.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-018837f5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/user/UserLoginView.vue
// module id = 2059
// module chunks = 1